/*
 * @Author: lixin jiang
 * @Date: 2021-07-15 16:32:35
 * @LastEditTime: 2021-07-15 16:33:49
 * @LastEditors: lixin jiang
 * @Description:
 * @FilePath: /aid-base/src/components/GroupRectCheckbox/index.js
 * @
 */
import GroupRectCheckbox from './groupRectCheckbox';

export default GroupRectCheckbox;
